<template>
  <div class="table1">
    <el-table :data="list" height="850" style="width: 100%" ref="table">
      <el-table-column prop="data1" label="序号" align="center" max-width='50px'></el-table-column>
      <el-table-column prop="" label="股票名称">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.data2}}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.data3 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="data4" label="细分行业" align="center"></el-table-column>
      <el-table-column prop="" label="原价" align="center" >
        <template slot-scope="scope">
          <div style="font-size: 15px">
            {{ scope.row.data5 }}
          </div>
          <div style="font-size: 10px">
            ({{ scope.row.data6 }})
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="data4" label="现价" align="center" >
        <template slot-scope="scope">
          <div style="font-size: 15px">
            {{ scope.row.data7 }}
          </div>
          <div style="font-size: 10px">
            ({{ scope.row.data8 }})
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="区间涨跌"
        align="center"
      >
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorGreen':scope.row.data9 < 0,'colorRed':scope.row.data9 > 0}">
            {{ scope.row.data9 }}%
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ths_conversion_premium_rate_cbond"
        label="股东类型"
        align="center"
      >
        <template slot-scope="scope">
          <div style="font-size: 15px">
            {{ scope.row.data10 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="data11"
        label="更新日期"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data12"
        label="股东名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data13"
        label="持股数(万)"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data14"
        label="市值(亿)"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data15"
        label="比例(%)"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data16"
        label="类型"
        align="center"
      ></el-table-column>
      <el-table-column
        prop=""
        label="增减仓"
        align="center"
      >
      <template slot-scope="scope">
          <div style="font-size: 15px" class="colorRed">
            {{ scope.row.data17 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="数量(万股)"
        align="center"
      >
      <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorGreen':scope.row.data9 < 0,'colorRed':scope.row.data9 > 0}">
            {{ scope.row.data18 }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {cbondList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[
        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },
                {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },        {
          data1:1,
          data2:'宁德时代',
          data3:'300750',
          data4:'家电',
          data5:58.6,
          data6:'10-02',
          data7:67.46,
          data8:'10-03',
          data9:15.73,
          data10:'十大流通股东',
          data11:'2016-06-30',
          data12:'高瓴资本管理有限公司高瓴资本...',
          data13:'4260.69',
          data14:'1.62',
          data15:'47.85',
          data16:'流通A股',
          data17:'增加',
          data18:1879.51,
        },
      ],
      page:1,
      page_number:20,
    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 400 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
        // if (scrollTop + windowHeight === scrollHeight) {
        //     // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
        //     if (!this.allData) this.getMoreLog()
        //     console.log('scrollTop', scrollTop + 'windowHeight', windowHeight + 'scrollHeight', scrollHeight)
        // }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){

    },
  }
};
</script>

<style scoped>
.table1 {
  min-width: 1427px;
  position: relative;
  overflow-x: scroll;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table1 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table1 /deep/ .cell{
  padding: 0;
}
.table1 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>